<template>
  <div>
    <!-- Modal/Delete component starts -->
    <delete-modal
      :subject="$t(`${type}`)"
      @cancel="closeModal('delete')"
      @deleteConfirmed="deleteConfirmed"
    />
    <!-- Modal/Delete component ends -->

    <!-- Modal/Update-Create component starts -->
    <update-modal
      type="update"
      :name="type"
      :fields="fields"
      :item="item"
      @save="saveChanges"
    />
    <!-- Modal/Update-Create component ends -->

    <!-- Modal Upload modal -->
    <upload-excel-modal :companyId="itemId" />

    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden shadow-md rounded">
            <table class="min-w-full bg-primary">
              <thead class="bg-primary border-b">
                <tr>
                  <th scope="col" class="admin-table-header" v-for="field in fields" :key="field">
                    {{ $t(`${field}`) }}
                  </th>
                  <th scope="col" class="admin-table-header"
                   v-if="type !== 'logs' && type !== 'meeting'">
                    {{ $t(`manage`) }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-primary">
                <tr class="admin-table-row" v-for="(item, index) in items" :key="index">
                  <td class="admin-table-cell" v-for="field in fields" :key="field">
                    <!-- if tab is on company  -->
                    <div
                      v-if="field === 'logo'"
                      class="h-40 w-40 object-cover overflow-hidden rounded"
                    >
                      <img
                        v-if="item[field]"
                        class="w-40"
                        :src="resizer(item[field])"
                        alt="company avatar"
                        @error="OnImageError"
                      />
                      <name-avatar v-else size="40" :text="item['name']" />
                    </div>
                    <!-- if tab is on company  -->
                    <div
                      v-else-if="field === 'avatar'"
                      class="h-40 w-40 object-cover overflow-hidden rounded"
                    >
                      <img
                        v-if="item[field]"
                        class="w-40"
                        :src="resizer(item[field])"
                        alt="User avatar"
                        @error="OnImageError"
                      />
                      <name-avatar v-else size="40" :text="item['name']" />
                    </div>
                    <span v-else>
                      <span v-if="type === 'users'" dir="ltr">
                        <span v-if="item.is_admin" class="text-primary font-bold">{{
                          item[field]
                        }}</span>
                        <span v-else dir="ltr">{{ item[field] }}</span>
                      </span>
                      <span v-else dir="ltr">{{ item[field] }}</span>
                    </span>
                  </td>
                  <td class="admin-table-role">
                    <span
                      dir="ltr"
                      class="admin-table-cell-text"
                      @click="syncAdminRole(item.id)"
                      v-if="type === 'users'"
                      title="Set as admin"
                    >
                      <user-admin
                        width="16"
                        height="16"
                        class="inline"
                        :color="item.is_admin ? '#34C759' : '#12131A'"
                      />
                    </span>
                    <span
                      dir="ltr"
                      class="admin-table-cell-text"
                      @click="loginAsUser(item.id)"
                      v-if="type === 'users'"
                      title="login as user"
                    >
                      <user-avatar width="16" height="16" class="inline" />
                    </span>
                    <span
                      dir="ltr"
                      v-if="type === 'companies'"
                      class="admin-table-cell-text"
                      @click="openExcelModalHandler(item.id)"
                    >
                      <upload-icon width="16" height="16" class="inline" />
                    </span>
                    <span
                      dir="ltr"
                      class="admin-table-cell-text"
                      @click="loginAsUser(item.owner_id)"
                      v-if="type === 'companies'"
                      title="Login As owner"
                    >
                      <user-avatar width="16" height="16" class="inline" />
                    </span>
                    <span class="admin-table-cell-text" @click="edit(item)"
                     v-if="type !== 'logs' && type !== 'meeting'" dir="ltr">
                      <edit width="16" height="16" class="popover-img" color="#0071FF" />
                    </span>
                    <span
                      class="admin-table-cell-text"
                      @click="deleteItem(item.id)"
                      v-if="type !== 'logs' && type !== 'meeting'"
                      dir="ltr"
                    >
                      <trash width="16" height="16" class="popover-img" color="#C8102E" />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Edit from '@/assets/icons/vue/edit.vue';
import Trash from '@/assets/icons/vue/trash.vue';
import AddUserIcon from '@/assets/icons/svg/white-add.svg';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import UpdateModal from '@/components/modals/UpdateModal.vue';
import UploadExcelModal from '@/components/modals/UploadExcelModal.vue';
import UserAvatar from '@/assets/icons/vue/user.vue';
import UploadIcon from '@/assets/icons/vue/UploadIcon.vue';
import UserAdmin from '@/assets/icons/vue/verify.vue';
import NameAvatar from '@/components/base/BaseNameAvatar.vue';
import { OnImageError } from '@/utils/on-image-error';
import imageResizer from '@/utils/image-resizer';

export default {
  name: 'Table',
  data() {
    return {
      OnImageError,
      AddUserIcon,
      item: [],
      itemId: 0,
      imageSize: 150,
    };
  },
  components: {
    DeleteModal,
    UpdateModal,
    UploadExcelModal,
    Edit,
    Trash,
    UserAvatar,
    NameAvatar,
    UserAdmin,
    UploadIcon,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    resizer(image) {
      return imageResizer(image, this.imageSize);
    },
    loginAsUser(itemId) {
      this.$emit('loginAsUser', itemId);
    },
    openExcelModalHandler(itemId) {
      this.itemId = itemId;
      this.openModal('uploadExcel');
    },
    syncAdminRole(itemId) {
      // eslint-disable-next-line no-restricted-globals, no-alert
      const confirmSubmit = confirm('Are you sure?');
      if (confirmSubmit) {
        this.$emit('syncAdmin', itemId);
      }
    },
    deleteItem(itemId) {
      this.itemId = itemId;
      this.openModal('delete');
    },
    closeModal(name) {
      this.$store.dispatch('modal/close', name);
    },
    deleteConfirmed() {
      this.$emit('deleteItem', this.itemId);
    },
    openModal(name) {
      this.$store.dispatch('modal/open', name);
    },
    edit(item) {
      this.$store.dispatch('updateAdminPanelItem', JSON.parse(JSON.stringify(item)));
      this.openModal('update');
    },
    saveChanges(item) {
      this.$emit('saveItem', item);
    },
  },
};
</script>

<style lang="css" scoped>
.admin-table-cell-text {
  @apply text-center p-8 mx-1 hover:bg-secondary hover:rounded-full cursor-pointer;
}
.admin-table-cell {
  @apply px-6 py-4 whitespace-nowrap text-sm font-medium text-left;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: 0; /* Firefox */
  max-width: 200px;
  overflow-x: auto;
}
.admin-table-cell::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.admin-table-cell:is(:lang(fa), :lang(ar)) {
  @apply text-right;
}
.admin-table-role {
  @apply admin-table-cell flex justify-start;
}
.admin-table-row {
  @apply bg-primary transition duration-300 ease-in-out text-subtitle
  hover:bg-secondary hover:text-title;
}
.admin-table-header {
  @apply text-sm font-medium text-title px-6 py-4 text-left;
}
.admin-table-header:is(:lang(fa), :lang(ar)) {
  @apply text-right;
}
</style>
